import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface BuyButtonProps {
  href: string;
  children: React.ReactNode;
  className?: string;
}

/**
 * Botón de compra en verde claro, con sombra sólida detrás y un bounce leve
 * para atraer la mirada hacia el punto de conversión.
 */
export function BuyButton({
  href,
  children,
  className = ''
}: BuyButtonProps) {
  const reduceMotion = useReducedMotion();
  return <motion.a href={href} className={['block w-full rounded-lg bg-leaf px-8 py-4 text-center text-base font-bold tracking-tight text-white sm:text-lg', 'shadow-[0_6px_0_0_#2e7d32,0_14px_24px_-10px_rgba(46,125,50,0.55)]', 'transition-[background-color,box-shadow,transform] duration-150 ease-smooth', 'hover:bg-leaf-dark active:translate-y-[5px] active:shadow-[0_1px_0_0_#2e7d32,0_6px_14px_-8px_rgba(46,125,50,0.5)]', 'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-forest', className].join(' ')} animate={reduceMotion ? undefined : {
    y: [0, -4, 0]
  }} transition={reduceMotion ? undefined : {
    duration: 0.7,
    times: [0, 0.4, 1],
    ease: [0.23, 1, 0.32, 1],
    repeat: Infinity,
    repeatDelay: 2.2
  }} data-id="element-382" data-mp="z6m0dvzh7yae">
      {children}
    </motion.a>;
}